"use strict";

exports.__esModule = true;
exports.getNonWidgetProps = getNonWidgetProps;
/**
 * Filter out widget related properties from the given input object.
 */
function getNonWidgetProps(input) {
  var output = {};
  var keys = Object.keys(input);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key === "element" || key === "render" || key === "type" || key === "path" || key === "widgets") {
      continue;
    }
    output[key] = input[key];
  }
  return output;
}